import { withInstall, withNoopInstall } from '@bigin/utils'

import Radio from './src/radio.vue'
import RadioButton from './src/radio-button.vue'
import RadioGroup from './src/radio-group.vue'

export const BRadio = withInstall(Radio, {
  RadioButton,
  RadioGroup,
})
export default BRadio
export const BRadioGroup = withNoopInstall(RadioGroup)
export const BRadioButton = withNoopInstall(RadioButton)

export * from './src/radio'
export * from './src/radio-group'
export * from './src/radio-button'
